/*
 * Different useful functional helpers
 */

/**
 * Noop function, doing nothing, returns undefined
 */
export const noop = (): void => undefined
